import { isPrivatePath, legacyAppPath } from "./const/appRoutes";

const SESSION_HANDOFF_PATHS = ["/landing"];

export function hasSessionCandidate({ accessToken, search = "", telegramRuntime = false }) {
  const params = new URLSearchParams(search);
  return Boolean(
    accessToken ||
    params.has("accessToken") ||
    params.has("emailVerify") ||
    telegramRuntime,
  );
}

export function shouldShowSessionGate({
  pathname,
  loading,
  isAuthorized,
  hasCandidate,
}) {
  if (isAuthorized && (pathname === "/" || SESSION_HANDOFF_PATHS.includes(pathname) || pathname.startsWith("/ref_"))) {
    return true;
  }

  if (!isAuthorized && (
    SESSION_HANDOFF_PATHS.includes(pathname) ||
    isPrivatePath(pathname) ||
    legacyAppPath(pathname) ||
    pathname.startsWith("/ref_")
  )) {
    return true;
  }

  return !isAuthorized && loading && hasCandidate;
}
